import { Box, Spacer } from '@jfs/ui-new'
import { StackActions, useNavigation, useRoute } from '@react-navigation/core'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { AadhaarCardStatusModel } from '../../comps/AadhaarLinkStatusModel'
import { AepsCheckBox } from '../../comps/AepsCheckBox'
import { Container } from '../../comps/Container'
import { ProgressDialog } from '../../comps/ProgressDialog'
import { RowItem } from '../../comps/RowItem'
import { ScanUserAuth } from '../../comps/ScanUserAuth'
import { Title } from '../../comps/Title'
import { RootStore, useLazyApiData, useStores } from '../../data/store'
import { Screens } from '../../nav/Screens'
import { nativeJSComm, nativeJSMapper } from '../../util/WebFns'
import {
  getFingerPrintData,
  getMaskedAadhaarNumber,
  getMaskedMobileNumber,
  getMaskedVIDNumber,
  parseBioMetricDeviceInfo,
} from '../../util/utill'

export const ReviewFundTransferScreen = () => {
  const navigation = useNavigation()
  const route: any = useRoute()

  const [checked, setChecked] = useState(false)
  const [shouldShowFingerPrintModel, setShouldShowFingerPrintModel] = React.useState(false)
  const [fingerPrintError, setFingerPrintError] = React.useState({ code: '', error: '', title: '' })
  const [aadhaarCardStatusInfoModel, setAadhaarCardInfoModel] = React.useState({ show: false, type: 'NOT_LINKED' })
  const authModeRef = React.useRef(null)

  const { getConsentDetails, fundTransferApi, getBankId, setBioMetricDeviceInfo, sendEventAsync } =
    useStores((root) => ({
      getConsentDetails: root.consents.getConsentDetails,
      fundTransferApi: root.customer.fundTransferApi,
      getBankId: root.banks.getBankId,
      setBioMetricDeviceInfo: root.agent.setBioMetricDeviceInfo,
      sendEventAsync: root.agent.session.sendEventAsync,
    }))
  const [lazyfundTransferApi, fundTransferApiHandler] = useLazyApiData(fundTransferApi)
  const consentDetails = getConsentDetails(route?.params?.activityType)
  useEffect(() => {
    navigation.setOptions({ headerTitle: 'Fund Transfer' })
  }, [navigation])

  useEffect(() => {
    if (fundTransferApiHandler.state === 'fulfilled') {
      const showRetry = fundTransferApiHandler?.data?.responseCode !== 'WL'
      navigation.goBack()
      navigation.dispatch(
        StackActions.replace(
          Screens.CASH_WITHDRAWAL_STATUS as never,
          {
            ...route.params,
            authMode: authModeRef?.current,
            consentDetails,
            showRetry,
            type: 'fund_transfer',
          } as never,
        ),
      )
    }
  }, [consentDetails, fundTransferApiHandler, navigation, route.params])

  useEffect(() => {
    if (fundTransferApiHandler.state === 'rejected' && fundTransferApiHandler?.data?.data?.responseCode === '22413') {
      !aadhaarCardStatusInfoModel.show && setAadhaarCardInfoModel({ show: true, type: 'NOT_LINKED' })
    }
  }, [aadhaarCardStatusInfoModel.show, fundTransferApiHandler, fundTransferApiHandler.state])

  const onScanSuccess = (sucess: any) => {
    getFingerPrintData(sucess, consentDetails?.text1, authModeRef.current).then((fingerprintData: any) => {
      setShouldShowFingerPrintModel(false)
      setBioMetricDeviceInfo(parseBioMetricDeviceInfo(fingerprintData))
      sendEventAsync({
        status: 'FINGERPRINT_CAPTURED',
        biometricDeviceInfo: RootStore.agent.deviceInfo.biometricDeviceInfo,
      })
      lazyfundTransferApi({
        aadhaarNumber: route.params.aadhaarNo,
        vid: route.params.vid,
        bankId: getBankId(route.params.bankName, 'CUSTOMER_FT'),
        bankName: route.params.bankName,
        mobileNo: route.params.mobileNo,
        amount: route.params.amount,
        beneficieryBankName: route.params.beneficieryBankName,
        beneficieryBankId: getBankId(route.params.beneficieryBankName, 'CUSTOMER_FT'),
        beneficieryAadhaar: route.params.beneficieryAadhaar,
        beneficieryVid: route.params.beneficieryVid,
        fingerprintData,
        consentDetails,
        authMode: authModeRef.current,
      })
    })
  }

  const onScanError = (error: any) => {
    sendEventAsync({
      status: 'FINGERPRINT_ERROR',
      errorDescription: error,
    })
    setFingerPrintError(JSON.parse(error))
  }

  const onPress = (authMode: 'FACE' | 'FINGER_PRINT') => {
    authModeRef.current = authMode
    setFingerPrintError({ code: '', error: '', title: '' })

    if (window?.AepsWebViewInterface) {
      setShouldShowFingerPrintModel(true)
      nativeJSComm(nativeJSMapper.scanFingerPrint, onScanSuccess, onScanError, { authMode })
    } else {
      lazyfundTransferApi({
        aadhaarNumber: route.params.aadhaarNo,
        vid: route.params.vid,
        bankId: getBankId(route.params.bankName, 'CUSTOMER_FT'),
        bankName: route.params.bankName,
        mobileNo: route.params.mobileNo,
        amount: route.params.amount,
        beneficieryBankName: route.params.beneficieryBankName,
        beneficieryBankId: getBankId(route.params.beneficieryBankName, 'CUSTOMER_FT'),
        beneficieryAadhaar: route.params.beneficieryAadhaar,
        beneficieryVid: route.params.beneficieryVid,
        consentDetails,
        authMode,
      })
    }
  }

  const goBackToHomeScreen = () => {
    setAadhaarCardInfoModel({ show: false, type: 'NOT_LINKED' })
    navigation.canGoBack() && navigation.goBack()
    navigation.canGoBack() && navigation.goBack()
  }

  const onAadhaarCardLinked = () => {
    setAadhaarCardInfoModel({ show: true, type: 'LINKED' })
  }

  const onPrimaryButtonClick = () => {
    setAadhaarCardInfoModel({ show: false, type: 'NOT_LINKED' })
    if (aadhaarCardStatusInfoModel.type == 'NOT_LINKED') {
      navigation.navigate(Screens.ENTER_CUSTOMER_MOBILE as never, { ...route?.params, onAadhaarCardLinked } as never)
    } else {
      onPress(authModeRef?.current)
    }
  }

  return (
    <Container showFooter={true} showBrandLogo={true}>
      <Box f={1} overflow={'scroll'}>
        <Title title="Review Transaction Details" />
        <Spacer size={32} />
        {route.params?.aadhaarNo && (
          <RowItem heading={'Payer’s Aadhar'} detail={getMaskedAadhaarNumber(route.params?.aadhaarNo)} />
        )}
        {route.params?.vid && <RowItem heading={'Payer’s VID'} detail={getMaskedVIDNumber(route.params?.vid)} />}
        <Spacer size={8} />
        <RowItem heading={'Bank Name'} detail={route.params?.bankName} />
        <Spacer size={8} />
        {route.params.mobileNo && (
          <>
            <RowItem heading={'Mobile'} detail={getMaskedMobileNumber(route.params.mobileNo)} />
            <Spacer size={8} />
          </>
        )}
        <RowItem heading={'Amount to be Transferred'} detail={`₹${route.params?.amount}`} />
        <Spacer size={24} />
        <Box borderStyle={'dashed'} borderTopWidth={0.5} borderColor={'PRIMARY_GREY'} height={1} width={'100%'} />
        <Spacer size={24} />
        <AepsCheckBox
          text={consentDetails?.text1}
          checked={checked}
          onChange={(isChecked: boolean) => setChecked(isChecked)}
        />
      </Box>
      <ScanUserAuth onPress={onPress} isLoading={fundTransferApiHandler.state === 'pending'} disabled={!checked} />

      <ProgressDialog
        error={fingerPrintError}
        onRetry={onPress}
        show={shouldShowFingerPrintModel || fundTransferApiHandler.state === 'pending'}
        type={fingerPrintError.code ? 'error' : fundTransferApiHandler.state === 'pending' ? 'loader' :  authModeRef.current==="FACE"?
          'face':
          'fingerprint'}
        onCancel={() => {
          setShouldShowFingerPrintModel(false)
          setFingerPrintError({ code: '', error: '', title: '' })
        }}
      />
      <AadhaarCardStatusModel
        status={aadhaarCardStatusInfoModel.type as any}
        show={aadhaarCardStatusInfoModel.show}
        onPrimaryButtonPress={onPrimaryButtonClick}
        onSecondaryButtonPress={goBackToHomeScreen}
      />
    </Container>
  )
}
